module.exports = __webpack_public_path__ + "img/vipLogo1.ec7c08a6.png";